/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FormElementType = {
    Select: 'SELECT',
    Checkbox: 'CHECKBOX',
    Radiobutton: 'RADIOBUTTON',
    Textfield: 'TEXTFIELD',
    Textarea: 'TEXTAREA',
    Switch: 'SWITCH',
    RichText: 'RICH_TEXT',
    Date: 'DATE',
    Table: 'TABLE',
    FileUpload: 'FILE_UPLOAD',
    InfoText: 'INFO_TEXT',
    WorksCouncilType: 'WORKS_COUNCIL_TYPE',
    WorksCouncilTypeEstablishment: 'WORKS_COUNCIL_TYPE_ESTABLISHMENT'
} as const;
export type FormElementType = typeof FormElementType[keyof typeof FormElementType];


export function instanceOfFormElementType(value: any): boolean {
    for (const key in FormElementType) {
        if (Object.prototype.hasOwnProperty.call(FormElementType, key)) {
            if (FormElementType[key as keyof typeof FormElementType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FormElementTypeFromJSON(json: any): FormElementType {
    return FormElementTypeFromJSONTyped(json, false);
}

export function FormElementTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormElementType {
    return json as FormElementType;
}

export function FormElementTypeToJSON(value?: FormElementType | null): any {
    return value as any;
}

export function FormElementTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FormElementType {
    return value as FormElementType;
}

